export default "__VITE_ASSET__C_1rHssk__"